'use client';
import { Box, Typography } from '@mui/material';

import { ErrorBoundary } from '@/components';
import { useT } from '@/hooks';

export const CalendarHeader = ({ currentMonth }: { currentMonth: string }) => {
  const { t } = useT();
  return (
    <ErrorBoundary
      fallback={
        <Box p={2} color="error.main">
          {t('earnings.failedToLoadHeader')}
        </Box>
      }
    >
      <Box sx={{ textAlign: 'center', mb: 3, mt: 2 }}>
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500, mb: 1 }}>
          {currentMonth}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.875rem' },
            fontWeight: 700,
            color: 'text.primary',
          }}
        >
          {t('earnings.calendar')}
        </Typography>
      </Box>
    </ErrorBoundary>
  );
};
